<template>
  <div>
    <v-dialog v-model="show" width="650" persistent>
      <v-card>
        <v-card-text>
          <v-title>Login</v-title>
          <v-container class="align">
            <div v-if="!$auth.loading">
              <!-- show login when not authenticated -->
              <button v-if="!$auth.isAuthenticated" @click="login">Log in</button>
              <!-- show logout when authenticated -->
              <button v-if="$auth.isAuthenticated" @click="logout">Log out</button>
            </div>
            <v-row>
              <v-col sm="12">
                <v-form ref="login" @submit.prevent="submit">
                  <v-col cols="12">
                    <v-text-field
                      name="email"
                      id="email"
                      label="Email"
                      type="email"
                      prepend-icon="person"
                      required
                      :rules="emailRules"
                      v-model="username"
                      browser-autocomplete="email"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-text-field
                      name="password"
                      id="password"
                      label="Password"
                      prepend-icon="lock"
                      v-model="password"
                      type="password"
                      browser-autocomplete="current-password"
                      :rules="passwordRules"
                      required
                    ></v-text-field>
                  </v-col>

                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn type="submit" small color="primary">Login</v-btn>
                    <v-btn small @click.stop="clear">clear</v-btn>
                  </v-card-actions>
                </v-form>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import { createHelpers } from "vuex-map-fields";
const { mapActions: mapAuthActions } = createNamespacedHelpers(`auth`);
export const { mapFields: mapAuthFields } = createHelpers({
  getterType: `auth/getField`,
  mutationType: `auth/updateField`
});
export const { mapFields: mapMessageFields } = createHelpers({
  getterType: `message/getField`,
  mutationType: `message/updateField`
});

export default {
  name: "app-lock",
  data () {
    return {
      show: true,
      username: null,
      password: null,
      emailRules: [
        v => !!v || "E-mail is required",
        v => /.+@.+/.test(v) || "E-mail must be valid"
      ],
      passwordRules: [v => !!v || "Password is required"]
    };
  },
  methods: {
    ...mapAuthActions(["handleAuthentication", "passwordLogin", "reset"]),
    login () {
      this.$auth.loginWithRedirect();
    },
    // Log the user out
    logout () {
      this.$auth.logout({
        returnTo: window.location.origin
      });
    },
    submit () {
      const vm = this;
      if (this.$refs.login.validate()) {

        vm.passwordLogin({
          username: vm.username,
          password: vm.password
        }).catch(() => { });
      }
    },
    clear () {
      this.$refs.login.reset();
      this.reset();
    }
  },
  computed: {
    ...mapMessageFields(["message"])
  },
  mounted () {
    this.reset();
  }
};
</script>

<style scoped>
</style>
